import { Reorder, useDragControls } from "framer-motion";
import type { FC } from "react";
import type {
  Control,
  FieldArrayWithId,
  UseFieldArrayRemove,
} from "react-hook-form";

import type { ForkSchema } from "../schema";
import ScriptControlLite from "./ScriptControlLite";

interface ScriptControlProps {
  control: Control<ForkSchema, any>;
  name: "scripts";
  index: number;
  field: FieldArrayWithId<ForkSchema, "scripts", "id">;
  removeScript: UseFieldArrayRemove;
}

const ScriptControl: FC<ScriptControlProps> = props => {
  const { control, name, index, field, removeScript } = props;
  const controls = useDragControls();
  return (
    <Reorder.Item value={field} dragListener={false} dragControls={controls}>
      <div className="flex flex-col gap-y-1 px-2 py-1 border rounded-md">
        <ScriptControlLite
          control={control}
          name={name}
          index={index}
          onStartDrag={e => controls.start(e)}
          removeScript={removeScript}
        />
      </div>
    </Reorder.Item>
  );
};

export default ScriptControl;
